import { Box, useDisclosure } from "@chakra-ui/react";
import { useContext } from "react";

import { TenantContext } from "@nens/ranalib";

import { PUBLICATION_SEARCH_KEY } from "@/config/query-parameter-consts";
import { useRanaSearchState } from "@/hooks/router/rana-search-state";
import { Profile } from "@/lib/profile";
import { usePublicationQuery } from "@/queries/query-publication";

import { PublicationPublicAccountModal } from "./components/public-account-modal";

export function PublicationPublicAccountModalButton() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const authInfo = useContext(TenantContext);
  const { isPublic, user } = authInfo;
  const userWithId = { ...user, id: "id" in user ? user.id : "-" };

  const [publicationId] = useRanaSearchState<string | undefined>(
    PUBLICATION_SEARCH_KEY,
    undefined,
    ["string", "undefined"]
  );
  const { data: publication } = usePublicationQuery(publicationId);

  /* XXX I think this can not happen here */
  if (!isPublic || "id" in user) return <Profile user={userWithId} />;

  const { setPublicUser } = authInfo;

  return (
    <>
      <Box cursor="pointer" onClick={onOpen}>
        <Profile noModal user={userWithId} />
      </Box>

      {isOpen && publication && publicationId && (
        <PublicationPublicAccountModal
          publication={publication}
          publicationId={publicationId}
          onClose={onClose}
          initialUser={user}
          setPublicUser={setPublicUser}
        />
      )}
    </>
  );
}
